import { render } from "./Dropdown.vue?vue&type=template&id=67645520"
import script from "./Dropdown.vue?vue&type=script&lang=js"
export * from "./Dropdown.vue?vue&type=script&lang=js"
script.render = render

export default script